import { Body } from '@lendi-ui/typography';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { depth } from '@lendi-ui/depth';
import { py, px } from '@lendi-ui/spacing';
import { deriveSize } from '@lendi-ui/utils';
import getColour from '@lendi-ui/commons/colours';
import { getRadius } from '@lendi-ui/commons/borders';
import getTypography from '@lendi-ui/commons/typography';
import { jsxs, jsx } from 'react/jsx-runtime';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var TooltipWrapper = styled.span.withConfig({
  displayName: "indexstyle__TooltipWrapper",
  componentId: "lui__sc-16ro6qx-0"
})(["position:relative;"]);
var ContentWrapper = styled.div.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-16ro6qx-1"
})(["font-family:", ";font-weight:", ";color:", ";background-color:", ";border-radius:", ";", ";", ";max-width:", ";min-width:", ";width:max-content;z-index:3;text-align:left;", ";overflow:hidden;position:absolute;transition:opacity 0.35s ease 0s;", ";", ";"], getTypography('body1', 'fontFamily'), getTypography('body1', 'fontWeight'), getColour('text', 'main'), getColour('background', 'container'), getRadius(), py('sm'), px('xxs'), deriveSize(16.25), deriveSize(3.75), depth(3), _ref => {
  var {
    isOpen
  } = _ref;
  if (isOpen) {
    return css(["visibility:visible;"]);
  } else {
    return css(["visibility:hidden;position:absolute;z-index:1;opacity:0;transition:opacity 0.6s;"]);
  }
}, _ref2 => {
  var {
    position
  } = _ref2;
  switch (position) {
    case 'top':
      return css(["bottom:calc(100% + ", ");left:50%;transform:translateX(-50%);"], deriveSize(0.5));
    case 'bottom':
      return css(["top:calc(100% + ", ");left:50%;transform:translateX(-50%);"], deriveSize(0.5));
    case 'left':
      return css(["right:calc(100% + ", ");top:50%;transform:translateY(-50%);"], deriveSize(0.5));
    case 'right':
      return css(["left:calc(100% + ", ");top:50%;transform:translateY(-50%);"], deriveSize(0.5));
  }
});

class Tooltip extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isOpen: false
    });
    _defineProperty(this, "hammer", undefined);
    _defineProperty(this, "_isMounted", false);
    _defineProperty(this, "myRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "changeOpenStatus", bool => {
      if (this._isMounted) {
        if (bool) {
          var _this$props$onOpen, _this$props;
          (_this$props$onOpen = (_this$props = this.props).onOpen) === null || _this$props$onOpen === void 0 ? void 0 : _this$props$onOpen.call(_this$props);
        }
        this.setState({
          isOpen: bool
        });
      }
    });
  }
  componentDidMount() {
    this._isMounted = true;
    if (typeof window !== "undefined") {
      var Hammer = require('hammerjs');
      var hammer;
      var manager = new Hammer.Manager(this.myRef.current);
      var Press = new Hammer.Press({
        time: 300
      });
      manager.add(Press);
      manager.on('press', () => {
        var _this$props$onOpen2, _this$props2;
        (_this$props$onOpen2 = (_this$props2 = this.props).onOpen) === null || _this$props$onOpen2 === void 0 ? void 0 : _this$props$onOpen2.call(_this$props2);
        this.setState({
          isOpen: true
        });
      });
      hammer = new Hammer(document.body, {
        cssProps: {
          userSelect: 'auto'
        }
      });
      hammer.on('tap', e => {
        if (e.target !== this.myRef.current) {
          this.setState({
            isOpen: false
          });
        }
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (typeof this.hammer !== 'undefined') {
      this.hammer.destroy();
    }
  }
  render() {
    var {
      content,
      position = 'right',
      children,
      className,
      onClick: _onClick
    } = this.props;
    var {
      isOpen
    } = this.state;
    return /*#__PURE__*/jsxs(TooltipWrapper, {
      ref: this.myRef,
      onMouseEnter: () => this.changeOpenStatus(true),
      onMouseLeave: () => this.changeOpenStatus(false),
      className: className,
      onClick: () => {
        this.changeOpenStatus(true);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      },
      children: [children, /*#__PURE__*/jsx(ContentWrapper, {
        isOpen,
        position,
        children: /*#__PURE__*/jsx(Body, {
          size: "sm",
          color: 'shade.700',
          children: content
        })
      })]
    });
  }
}

export { Tooltip as default };
